var storefrontApp = angular.module('storefrontApp');
storefrontApp.service('sitemapService', ['$http', function ($http) {
    return {


        getSiteMapContent: function () {
            return $http.get('sitemapcontent');
        },


    }
}
]);
